export enum EnterpriseFormFieldNameEnum {
  IFU = "ifu",
  PROFESSIONAL_RISK = "professional_risk",
  COMPANY_NAME = "name",
  CNSS = "cnss",
  TAXE_REGIME = "taxe_regime",
  ADDRESS = "address",
  COLLECTIVE_AGREEMENT = "collective_agreement",
  LEGAL_FORM = "legal_form",
  CONTACT = "contact",
  EMAIL = "email",
  ADMIN_EMAIL = "admin_email",
  LOGO = "logo",
  VPS_RATE = "vps_rate",
  VPS_END_DATE = "vps_end_date"
}

export type EnterpriseFormType = {
  ifu: string | null
  professional_risk: string | null
  name: string | null
  cnss: string,
  taxe_regime: string,
  address: string | null
  legal_form: string | null
  collective_agreement: string | null
  email: string | null
  admin_email: string | null
  contact: string | null
  logo: File | string
  is_active: boolean
  vps_rate: number | null,
  vps_end_date: Date | string
}

export const EnterpriseFormDefaultValues: EnterpriseFormType = {
  ifu: "",
  professional_risk: "",
  name: "",
  cnss: "",
  taxe_regime: "",
  address: "",
  legal_form: "",
  collective_agreement: "",
  email: "",
  admin_email: "",
  contact: "",
  logo: "",
  is_active: true,
  vps_rate: null,
  vps_end_date: "",
}
